export default __webpack_public_path__ + "static/Entenda0046-87cdfd089761b5b0a0073099432e3e5c.jpg";